export default "__VITE_ASSET__BzyymfYb__"